import { siteConfig } from "@/mocks/chiGuaData";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full bg-background-200/80">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-lg text-background-50">
                <i className="ri-chat-smile-fill" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">{siteConfig.brand}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              聚合热门事件、新鲜事与有趣话题，为你提供轻松的内容冲浪体验。浏览推荐不错过精彩，随时随地在线刷瓜。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-send-plane-line", "ri-instagram-line"].map(
                (icon) => (
                  <a
                    key={icon}
                    href="#top"
                    aria-label="关注我们"
                    className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600"
                  >
                    <i className={icon} aria-hidden="true"></i>
                  </a>
                )
              )}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">快速浏览</h4>
            <ul className="mt-4 flex flex-col gap-3">
              {[
                { href: "#hot", label: "热门瓜榜" },
                { href: "#fresh", label: "今日新鲜" },
                { href: "#browse", label: "分类浏览" },
                { href: "#guide", label: "冲浪指南" },
              ].map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">更多了解</h4>
            <ul className="mt-4 flex flex-col gap-3">
              {[
                { href: "#about", label: "关于我们" },
                { href: "#faq", label: "常见问题" },
              ].map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-5 text-sm text-foreground-600">
              合作与建议：hi@chiguawangshang.example
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {year} {siteConfig.brand} 版权所有 · 快乐吃瓜，理性冲浪
          </p>
          <p className="text-xs text-foreground-500">内容为示例演示 · 请理性看待网络信息</p>
        </div>
      </div>
    </footer>
  );
}